module.exports = __webpack_public_path__ + "img/google_tag.eb501e56.jpg";